"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const styles_1 = __importDefault(require("./styles"));
const popmotion_1 = require("popmotion");
class ReadMore extends lit_1.LitElement {
    constructor() {
        super();
        this.hasOverlay = false;
        this.opened = false;
        const resizeObserver = new ResizeObserver(() => {
            this.openedHeight = this.content?.scrollHeight;
        });
        resizeObserver.observe(document.body);
    }
    firstUpdated() {
        this.openedHeight = this.content?.getBoundingClientRect().height;
        this.style.setProperty("--wr-readmore-height", `${this.maxHeight}px`);
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has("opened")) {
            (0, popmotion_1.animate)({
                from: this.opened ? this.maxHeight : this.openedHeight,
                to: this.opened ? this.openedHeight : this.maxHeight,
                onUpdate: (v) => this.style.setProperty("--wr-readmore-height", `${v}px`), // this.openedHeight
            });
        }
    }
    render() {
        return (0, lit_1.html) ` <section class="read-more" aria-expanded="${this.opened}">
      <div
        class="read-more__content"
        ?data-overlay="${this.hasOverlay && !this.opened}"
      >
        <slot></slot>
      </div>

      ${(this.maxHeight ?? 0) < (this.openedHeight ?? 0)
            ? this.renderButton()
            : (0, lit_1.html) ``}
    </section>`;
    }
    renderButton() {
        return (0, lit_1.html) `<button
      class="read-more__button"
      @click="${() => (this.opened = !this.opened)}"
    >
      ${this.opened ? this.__renderCloseLabel() : this.__renderOpenLabel()}
    </button>`;
    }
    __renderCloseLabel() {
        return (0, lit_1.html) `<slot name="close-label">${this.closeLabel}</slot>`;
    }
    __renderOpenLabel() {
        return (0, lit_1.html) `<slot name="open-label">${this.openLabel}</slot>`;
    }
}
ReadMore.styles = styles_1.default;
__decorate([
    (0, decorators_js_1.property)({ attribute: "max-height" })
], ReadMore.prototype, "maxHeight", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: "has-overlay" })
], ReadMore.prototype, "hasOverlay", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: "open-label" })
], ReadMore.prototype, "openLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: "close-label" })
], ReadMore.prototype, "closeLabel", void 0);
__decorate([
    (0, decorators_js_1.state)()
], ReadMore.prototype, "openedHeight", void 0);
__decorate([
    (0, decorators_js_1.state)()
], ReadMore.prototype, "opened", void 0);
__decorate([
    (0, decorators_js_1.query)(".read-more__content")
], ReadMore.prototype, "content", void 0);
exports.default = ReadMore;
//# sourceMappingURL=Readmore.js.map